import { colors } from "constants/theme"

export default function IconUserPlusDis(props: { colors?: string }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="18.4" viewBox="0 0 23 18.4">
            <path d="M22.425 7.475h-2.3v-2.3a.577.577 0 0 0-.575-.575H18.4a.577.577 0 0 0-.575.575v2.3h-2.3a.577.577 0 0 0-.575.575V9.2a.577.577 0 0 0 .575.575h2.3v2.3a.577.577 0 0 0 .575.575h1.15a.577.577 0 0 0 .575-.575v-2.3h2.3A.577.577 0 0 0 23 9.2V8.05a.577.577 0 0 0-.575-.575zM8.05 9.2a4.6 4.6 0 1 0-4.6-4.6 4.6 4.6 0 0 0 4.6 4.6zm3.22 1.15h-.6a6.256 6.256 0 0 1-5.24 0h-.6A4.831 4.831 0 0 0 0 15.18v1.5a1.725 1.725 0 0 0 1.725 1.72h12.65a1.725 1.725 0 0 0 1.725-1.725v-1.5a4.831 4.831 0 0 0-4.83-4.825z" style={{ fill: props.colors || colors.themeSecondColor }} />
        </svg>
    )
}
